import request from '../request'

export const positionTagApi = {
  listPositionTag (params) {
    return request.get('/v2/admin/positionTags', { params: params })
  },
  getPositionTag (id) {
    return request.get('/v2/admin/positionTags/' + id)
  },
  savePositionTag (data) {
    return request.post('/v2/admin/positionTags', data)
  },
  updatePositionTag (id, data) {
    return request.put('/v2/admin/positionTags/' + id, data)
  },
  deletePositionTag (id) {
    return request.delete('/v2/admin/positionTags/' + id)
  },
}

export default positionTagApi
